import isObject from 'lodash-es/isObject';
import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { GenerateItem } from '../topic-widgets/generate-item';
const captions = new Set(['HCFigureCaption', 'HCCaptionTable']);
const factory = create({ theme }).properties();
export const Title = factory(({ properties }) => {
    const { title, widgetType = null, insection } = properties();
    let ele = widgetType === 'figure' ? (insection ? 'h6' : 'h5') : insection ? 'h4' : 'h1';
    let id = undefined;
    const kids = [];
    if (typeof title === 'string') {
        kids.push(title);
    }
    else {
        const { children = [], attributes } = (isObject(title) && 'title' in title ? title.title : title);
        if (attributes && attributes.outputclass && captions.has(attributes.outputclass)) {
            ele = 'figcaption';
            id = attributes.id;
        }
        if (children) {
            children.forEach((kid) => {
                const item = kid;
                kids.push(w(GenerateItem, { item }));
            });
        }
        else {
            kids.push(v('span', ['']));
        }
    }
    return v(ele, { id }, kids);
});
